import { Bell2Icon } from '@/assets/bell-2-icon';
import { NotificationList } from '@/features/notifications/components/notification-list.tsx';
import { Button } from '@/components/ui/button';
import { useGetNotificationsQuery } from '@/features/notifications/hooks/queries/get-all-notifications.ts';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner.tsx';

const Notifications = () => {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  const { data, fetchNextPage, isFetchingNextPage } = useGetNotificationsQuery({
    limit: 10,
    notificationFilter: 'all',
  });

  const notifications = data?.pages;

  useEffect(() => {
    if (inView) {
      fetchNextPage().then();
    }
  }, [inView, fetchNextPage]);

  return (
    <div className="mx-auto flex max-w-[1400px] flex-col">
      {/* <Navbar /> */}
      <ul className="flex flex-col gap-4 px-4 pt-4">
        {notifications?.length ? (
          <NotificationList />
        ) : (
          <div className="overview gap-2 px-4 pb-8">
            <div className="mt-44 flex flex-col items-center justify-center gap-4">
              <Bell2Icon height="100" width="100" strokeWidth="1" />
              <div className="space-y-2 text-center">
                <h2 className="text-2xl font-bold">{t('notifications.title')}</h2>
                <p className="text-lg">{t('notifications.description')}</p>
                <Button>{t('common.buttons.refreshButton')}</Button>
              </div>
            </div>
          </div>
        )}
        <li ref={ref}>
          {isFetchingNextPage && (
            <div className="flex w-full items-center justify-center py-2 pb-6">
              <LoadingSpinner className="text-muted-foreground size-10" />
            </div>
          )}
        </li>
      </ul>
    </div>
  );
};

export default Notifications;
